module.exports = __webpack_public_path__ + "static/media/1015060.09c56784.jpg";